import * as React from 'react';
import Box from '@mui/material/Box';
import { Typography } from '@mui/material';
import styles from './paper.module.scss'

const Paper = ({ children, heading, p, extraRender, className }) => {
    return (
        <Box sx={{ width: '100%', backgroundColor: "#E5E5E5", p: p || "24px 26px 20px" }} className={className}>
            <Typography className={styles.heading}>{heading}</Typography>
            {extraRender}
            <Box sx={{ backgroundColor: "#FFF", width: "100%" }}>
                {children}
            </Box>
        </Box>
    );
}

export default Paper
